import List from "@/components/list";
import router from "@/router";

const Table = (args) => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selectionChange"] || function() {};
  const download = listeners["download"] || function() {};

  function goClassDetail(row) {
    let query = { id: row.classId };
    if (row.classParentId) {
      query.parentId = row.classParentId
    }
    router.push({
      path: "offlineClass/detail",
      query: query,
    });
  }

  // function selectable(row, index) {
  //   if (row.downloadNum == 0) {
  //     return true
  //   }
  //   return false
  // }

  const Deal = ({ props: { vo } }) => {
    const { row } = vo;
    // console.log('-----', row);
    const dealConf = [];
    if (row.downloadNum == 0) {
      dealConf.push([
        "iconfont ic_a-qianshou-moren2x iconfont-adapt",
        "签收",
        () => download(row),
        "letterFile:download"
      ])
    } else {
      dealConf.push([
        "iconfont ic_download iconfont-adapt",
        "下载",
        () => download(row),
        "letterFile:download"
      ])
    }
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  }

  const ClassName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <span class="base-hover-char" onClick={() => goClassDetail(item)}>
        {item.className}
      </span>
    );
  };
  const SignStatus = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <span >
        {item.downloadNum == 0 ? '未签收' : '已签收' }
      </span>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
      // selectable: selectable
    },
    {
      label: "姓名",
      prop: "userName",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "180",
      showOverflowTooltip: true
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "200",
      showOverflowTooltip: true
    },
    {
      label: "参加班级",
      prop: "className",
      minWidth: "220",
      showOverflowTooltip: true,
      render: (vo) => <ClassName vo={vo} />
    },
    {
      label: "选调函",
      prop: "fileName",
      minWidth: "80",
      showOverflowTooltip: true
    },
    {
      label: "签收状态",
      prop: "modifyDate",
      minWidth: "70",
      showOverflowTooltip: true,
      render: vo => <SignStatus vo={vo}/>
    },
    {
      label: "发布时间",
      prop: "createDate",
      minWidth: "130",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      minWidth: "60",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ]
  return <List {...args}
               onSelectionChange={RCSelectionChange}
               talbeCols={AccountTableConfig} />;
}
export default Table;
    